import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Container, Row, Col } from "reactstrap"
import CardParametroAnio from './CardParametroAnio';

import "../../../../assets/scss/Horas Extras/ParametrosHorasExtras.scss"
import CardParametrosFechas from './ParametrosProyeccion/CardParametrosFechas';
import { ConsultarDetalleParametrosAnio, CrearParametrosPeriodoAnio, ActualizarParametrosPeriodoProyeccionHE, ObtenerInformacionGeneralParametrosHorasExtras } from './FunctionsParametrosHE';
import { DetalleParametrosProyeccionHE, DetalleParametrosRegimenProyeccionHE, InformacionGeneralParametrosHorasExtras } from './TypesParametrosHorasExtras';
import { alertService } from 'components/Varios/alert_service';
import Cargando from 'components/Varios/Cargando';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import ModalCargando from 'components/Varios/ModalCargando';
import { PruebaSolucion2 } from 'functions/DatesFunctions';
import CardHoras from './ParametrosProyeccion/Parametros Horas/CardHoras';
import CardPresupuestoHorasExtras from './ParametrosProyeccion/CardPresupuestoHorasExtras';
import CardPresupuestoAnualHE from './ParametrosProyeccion/CardPresupuestoAnualHE';
import CardPeriodosProyeccionHE from './ParametrosProyeccion/CardPeriodosProyeccionHE';
import ParametrosProyeccion from './ParametrosProyeccion/ParametrosProyeccion';
import CardAnioEjecucion from './CardAnioEjecucion';
import ParametrosPlanificacion from './ParametrosProyeccion/ParametrosPlanificacion';
import { SelectCombo } from 'components/Types/GeneralTypes';
import { showAlert } from './Actividades/ActividadesHorasExtras';
import { useParametrosMensualesHorasExtrasContext } from 'Context/ParametrosMensualesHorasExtrasContext';
import CardParametrosDocPago from './Documento Pago/CardParametrosDocPago';

export function HayParametrosHEDeAnio(detallesParametros: DetalleParametrosProyeccionHE | null) {
    if (detallesParametros === null) {
        return false;
    }
    else {
        const { fechafinasigpresupGPE, fechafinproyeccion, fechainicioasigpresupGPE, fechainicioproyeccion, listadoparametroshorasregimen, presupuestoAnualHE } = detallesParametros;
        return (fechainicioproyeccion !== null && fechafinproyeccion !== null) || (fechainicioasigpresupGPE !== null && fechafinasigpresupGPE !== null) || listadoparametroshorasregimen.length > 0 || presupuestoAnualHE != null

    }
}

function MapearListadoAniosOpciones(anios: number[] | undefined) {

    if (anios === undefined) {
        return []
    }

    const opcionesCombo: SelectCombo[] = anios.map((v) => {
        return {
            label: v.toString(),
            value: v.toString()
        }
    })

    return opcionesCombo
}





export default function NewParametrosPlanificacion() {



    const [informacionGeneralParametros, setinformacionGeneralParametros] = useState<InformacionGeneralParametrosHorasExtras | null>(null);
    const [loading, setloading] = useState<boolean>(false)

    const { anioParametrosSeleccionado,
        setanioParametrosSeleccionado,
        creandoParametros,
        setcreandoParametros,
        setguardandoParametro,
        parametrosHorasRegimen,
        setparametrosHorasRegimen,

    } = useParametrosMensualesHorasExtrasContext();



    async function ObtenerInformacionGeneral() {
        setloading(true)
        const informacionGeneral = await ObtenerInformacionGeneralParametrosHorasExtras("PL");
        if (informacionGeneral.status === 200 && informacionGeneral.dataResponse) {

            setinformacionGeneralParametros(informacionGeneral.dataResponse)
             //Para cambiar el valor de los Horas Regimen en el state
             if (informacionGeneral.dataResponse.parametrosPlanificacion) {
                setparametrosHorasRegimen(informacionGeneral.dataResponse.parametrosPlanificacion.listadoparametroshorasregimen)
            }            
            else {
                setparametrosHorasRegimen(null)
            }
            //

            // setanioParametrosSeleccionado(informacionGeneral.dataResponse.anio)
            // setparametrosHorasRegimen(informacionGeneral.dataResponse.listadoparametroshorasregimen)

        }
        else if (informacionGeneral.status === 401) {
            showAlert("Su usuario no se encuentra autorizado para verificar la información", false)
        }
        //No hay contenido, es null la informacion
        else {
            alertService.error(informacionGeneral.errorMessage);
        }
        setloading(false)
    }

    async function ConsultarDetalle(anioSeleccionado: number) {
        setloading(true)
        const detalleParametros = await ConsultarDetalleParametrosAnio(anioSeleccionado);
        if (detalleParametros.status === 200 && detalleParametros.dataResponse) {
            setinformacionGeneralParametros(detalleParametros.dataResponse)
            //Para cambiar el valor de los Horas Regimen en el state
            if (detalleParametros.dataResponse.parametrosPlanificacion) {
                setparametrosHorasRegimen(detalleParametros.dataResponse.parametrosPlanificacion.listadoparametroshorasregimen)
            }            
            else {
                setparametrosHorasRegimen(null)
            }
        }
        else if (detalleParametros.status === 401) {
            showAlert("Su usuario no se encuentra autorizado para verificar la información", false)
        }
        else {
            alertService.error(detalleParametros.errorMessage);
        }
        setloading(false)
    }

    // const CrearParametros = useCallback(
    //     async () => {

    //         if (informacionGeneralParametros !== null) {
    //             setcreandoParametros(true)

    //             var copiaInformacionGeneral = { ...informacionGeneralParametros };

    //             if (anioParametrosSeleccionado !== null) {
    //                 copiaInformacionGeneral.anio = anioParametrosSeleccionado;
    //             }

    //             NormalizeInformacionParametros(copiaInformacionGeneral);

    //             if (parametrosHorasRegimen !== null) {
    //                 copiaInformacionGeneral.listadoparametroshorasregimen = parametrosHorasRegimen;
    //             }

    //             const respuesta = await CrearParametrosPeriodoAnio(copiaInformacionGeneral);
    //             if (respuesta.status === 200 || respuesta.status === 204) {
    //                 alertService.success("Se han agregado/actualizado los parámetros sin novedad");
    //             }
    //             else {
    //                 alertService.error(respuesta.errorMessage)
    //             }

    //             setcreandoParametros(false)
    //             ConsultarDetalle(informacionGeneralParametros.anio);
    //         }
    //     },
    //     [informacionGeneralParametros, anioParametrosSeleccionado,parametrosHorasRegimen],
    // )


    // const ActualizarParametros = 
    //     async (informacionGeneralParametros: DetalleParametrosProyeccionHE | null, parametrosHoras:DetalleParametrosRegimenProyeccionHE[]|null) => {
    //         if (informacionGeneralParametros !== null) {
    //             setguardandoParametro(true);
    //             var copiaInformacionGeneral: DetalleParametrosProyeccionHE = { ...informacionGeneralParametros };
    //             NormalizeInformacionParametros(copiaInformacionGeneral);

    //             if(parametrosHoras != null){
    //                 copiaInformacionGeneral.listadoparametroshorasregimen = parametrosHoras;
    //             }

    //             const respuesta = await ActualizarParametrosPeriodoProyeccionHE(copiaInformacionGeneral);
    //             if (respuesta.status === 200 || respuesta.status === 204) {
    //                 alertService.success("Se han actualizado los parámetros sin novedad");
    //                 ConsultarDetalle(informacionGeneralParametros.anio);

    //             }
    //             else {
    //                 alertService.error(respuesta.errorMessage)
    //             }

    //             setguardandoParametro(false);

    //         }

    //     }








    useEffect(() => {
        ObtenerInformacionGeneral()
    }, [])




    useEffect(() => {
        if (informacionGeneralParametros !== null && informacionGeneralParametros.anio !== null) {
            setanioParametrosSeleccionado(informacionGeneralParametros.anio)
        }
    }, [informacionGeneralParametros?.anio])

    // useEffect(() => {

    //     //console.log(informacionGeneralParametros)
    //     if (informacionGeneralParametros !== null && informacionGeneralParametros.listadoparametroshorasregimen !== null) {
    //         setparametrosHorasRegimen(informacionGeneralParametros.listadoparametroshorasregimen);
    //     }
    // }, [informacionGeneralParametros])

    // const OnChangeFechas = useCallback(
    //     (tipo: string, value: string) => {
    //         if (value !== "") {
    //             if (informacionGeneralParametros === null && anioParametrosSeleccionado !== null) {

    //                 var nuevosParametros: DetalleParametrosProyeccionHE = {
    //                     anio: anioParametrosSeleccionado,
    //                     listadoparametroshorasregimen: [],
    //                     fechainicioproyeccion: null,
    //                     fechafinproyeccion: null,
    //                     fechainicioasigpresupGPE: null,
    //                     fechafinasigpresupGPE: null

    //                 }

    //                 if (tipo === "proyeccioninicio") {
    //                     nuevosParametros.fechainicioproyeccion = value
    //                 }
    //                 else if (tipo === "proyeccionfin") {
    //                     nuevosParametros.fechafinproyeccion = value
    //                 }

    //                 setinformacionGeneralParametros(nuevosParametros);

    //             }
    //             else if (informacionGeneralParametros !== null) {
    //                 if (tipo === "proyeccioninicio") {
    //                     setinformacionGeneralParametros({ ...informacionGeneralParametros, fechainicioproyeccion: value })
    //                 }
    //                 else if (tipo === "proyeccionfin") {
    //                     setinformacionGeneralParametros({ ...informacionGeneralParametros, fechafinproyeccion: value })
    //                 }
    //                 else if (tipo === "asignacioninicio") {
    //                     setinformacionGeneralParametros({ ...informacionGeneralParametros, fechainicioasigpresupGPE: value })

    //                 }
    //                 else if (tipo === "asignacionfin") {
    //                     setinformacionGeneralParametros({ ...informacionGeneralParametros, fechafinasigpresupGPE: value })

    //                 }
    //             }

    //         }
    //     },
    //     [informacionGeneralParametros, anioParametrosSeleccionado]
    // )




    // const OnChangePresupuesto = useCallback(
    //     (valor: number) => {
    //         if (informacionGeneralParametros === null && anioParametrosSeleccionado !== null) {
    //             var nuevosParametros: DetalleParametrosProyeccionHE = {
    //                 anio: anioParametrosSeleccionado,
    //                 listadoparametroshorasregimen: [],
    //                 fechainicioproyeccion: null,
    //                 fechafinproyeccion: null,
    //                 fechainicioasigpresupGPE: null,
    //                 fechafinasigpresupGPE: null

    //             }

    //             nuevosParametros.presupuestoAnualHE = valor;
    //             setinformacionGeneralParametros(nuevosParametros)


    //         }

    //         else if (informacionGeneralParametros !== null) {
    //             var copiaInformacionGeneralParametros = { ...informacionGeneralParametros }
    //             copiaInformacionGeneralParametros.presupuestoAnualHE = valor;
    //             setinformacionGeneralParametros(copiaInformacionGeneralParametros);

    //         }
    //     },
    //     [informacionGeneralParametros, anioParametrosSeleccionado,parametrosHorasRegimen],
    // )




    // return (

    //     <React.Fragment>


    //         {loading && <Cargando />}
    //         {!loading && (

    //             <Row>
    //                 <Col xl={6}>
    //                     <Row>
    //                         <Col xl={12}>
    //                             <CardParametroAnio
    //                                 detalleParametros={informacionGeneralParametros}
    //                                 onChangeAnio={(anio: number) => ConsultarDetalle(anio)}
    //                                 onCreateParametros={() => CrearParametros()}
    //                                 onActualizarParametros={() => ActualizarParametros(informacionGeneralParametros,parametrosHorasRegimen)}
    //                             />
    //                         </Col>


    //                     </Row>
    //                     <Row>
    //                         <Col xl={12}>
    //                             <CardPresupuestoHorasExtras
    //                                 detalleParametros={informacionGeneralParametros}
    //                                 onChangeValorPresupuesto={(valor) => OnChangePresupuesto(valor)}
    //                             />

    //                         </Col>
    //                     </Row>
    //                 </Col>
    //                 <Col xl={6}>
    //                     <Row>
    //                         <Col xl={12}>
    //                             <CardParametrosFechas
    //                                 detalleParametros={informacionGeneralParametros}
    //                                 onChangeFecha={(tipo: string, value: string) => OnChangeFechas(tipo, value)}
    //                             />
    //                         </Col>
    //                     </Row>
    //                 </Col>
    //                 <Col xl={12}>
    //                     <CardHoras
    //                         // detalleParametros={informacionGeneralParametros}
    //                         // onChangeHoras={(tipo: string, value: number | null, idregimen: number) => OnChangeHoras(tipo, value, idregimen)}
    //                         tipo='PR'
    //                     />
    //                 </Col>

    //             </Row>
    //         )}

    //         <ModalCargando
    //             show={creandoParametros}
    //             textoCargando='Guardando Parámetros'
    //             size='md'
    //             onClose={() => setcreandoParametros(false)}
    //         />
    //     </React.Fragment>


    // )


    var anioParametrosDePlanificacion = informacionGeneralParametros?.anio;



    return (

        <React.Fragment>


            {loading && <Cargando />}
            {!loading && (
                <Container fluid={true}>
                    <Row>
                        <Col xl={12}>
                            <Row>
                                <Col xl={6}>
                                    <CardAnioEjecucion
                                        anio={anioParametrosDePlanificacion}
                                        listadoAnios={MapearListadoAniosOpciones(informacionGeneralParametros?.listadoaniosdisponibles)}
                                        onChangeAnio={(anio: number) => ConsultarDetalle(anio)}
                                    />
                                </Col>
                                <Col xl={6}>
                                    {
                                        informacionGeneralParametros &&
                                        <CardParametrosDocPago
                                            listadoPersonal={informacionGeneralParametros.listadoPersonalDocPago}
                                            parametrosDocPago={informacionGeneralParametros.parametrosDocPago}
                                        />
                                    }

                                </Col>


                            </Row>
                        </Col>
                        <Col xl={12}>

                            <ParametrosPlanificacion
                                parametrosPlanificacion={informacionGeneralParametros?.parametrosPlanificacion}
                                anioParametros={informacionGeneralParametros?.anio}
                            />

                        </Col>


                    </Row>
                </Container>

            )}

            <ModalCargando
                show={creandoParametros}
                textoCargando='Guardando Parámetros'
                size='md'
                onClose={() => setcreandoParametros(false)}
            />
        </React.Fragment>


    )
}
